<template>
  <div v-if="filterForm">
    <!-- 添加日期选择器 -->
    <a-date-picker v-model="selectedDate" format="YYYY-MM-DD" style="margin-top: 10px" />
    <!-- 添加筛选按钮 -->
    <a-button type="primary" style="margin-left: 10px" @click="handleDateFilter">筛选</a-button>

    <!-- 动态展示选定日期 -->
    <a-card class="filter-data">
      <span slot="title" style="text-align: center; display: block; font-size: x-large">
        质量验收报告{{ currentDate ? '' + currentDate + '' : '' }}
        <a-button v-tc="{ name: '截图' }" type="dashed" style="margin-left: 5px" @click="screenshot">截图</a-button>
      </span>
    </a-card>

    <div ref="wholePage">
      <a-row :gutter="16">
        <a-col class="customer-col" :span="24">
          <daily-list ref="taskLists" :filter-form="filterForm" />
        </a-col>
      </a-row>
    </div>
  </div>
</template>
<script>
import DailyList from '@/pages/data/daily/components/DailyList';
import html2canvas from 'html2canvas';
import moment from 'moment';

export default {
  components: { DailyList },
  data() {
    return {
      selectedDate: null,
      filterForm: {
        date: null
      },
      currentDate: null
    };
  },
  onSearch() {
    this.$emit('change');
    this.$refs.dailyLists.getDailyData();
  },
  computed: {
    formattedCurrentDate() {
      return this.selectedDate ? this.selectedDate.format('YYYY-MM-DD') : this.currentDate;
    }
  },
  mounted() {
    this.currentDate = moment().format('YYYY-MM-DD');
    this.selectedDate = moment();
  },
  methods: {
    screenshot() {
      const that = this;
      html2canvas(this.$refs.wholePage, {
        backgroundColor: null,
        useCORS: true,
        scale: 1.2,
        ignoreElements: function (element) {
          if (element.classList && (element.classList.contains('ant-pagination') || element.classList.contains('issues-today'))) {
            return true;
          } else {
            return false;
          }
        }
      }).then(canvas => {
        canvas.toBlob(blob => {
          const data = [new ClipboardItem({ [blob.type]: blob })];
          navigator.clipboard.write(data).then(
            () => {
              that.$message.success('已保存到粘贴板');
            },
            () => {
              that.$message.warning('保存截图失败');
            }
          );
        }, 'image/png');
      });
    },
    handleDateFilter() {
      if (!this.selectedDate) {
        this.currentDate = moment().format('YYYY-MM-DD');
      } else {
        this.currentDate = this.selectedDate.format('YYYY-MM-DD');
      }
      const formattedDate = this.selectedDate ? this.selectedDate.format('YYYY-MM-DD') : null;
      this.filterForm.date = formattedDate;
      this.$refs.taskLists.getDailyData();
    }
  }
};
</script>
<style lang="less" scoped>
.customer-col {
  margin-top: 16px;
}

/deep/ .ant-col-8 {
  padding-left: 3px !important;
  padding-right: 3px !important;
}
</style>
